// INFO: Identifier for scrollable content on Threads history section
// Moved to a standalone file to avoid circular imports on build proccess

export const SCROLLABLE_SECTION = 'scrollable-area';

export const THREADS_LIST_TEST_IDS = {
  search: 'thread-search-input',
} as const;
